import { create } from "zustand";
import { translations } from "../18n/translations";

type Language = "en" | "fi";

interface LanguageStore {
  language: Language;
  t: (key: string) => string;
  setLanguage: (lang: Language) => void;
}

export const useLanguage = create<LanguageStore>((set, get) => ({
  language: "en",
  t: (key: string) => {
    const keys = key.split(".");
    let value = translations[get().language];
    for (const k of keys) {
      value = (value as Record<string, any>)?.[k];
    }
    return typeof value === "string" ? value : key;
  },
  setLanguage: (lang: Language) => set({ language: lang }),
}));
